"use strict";

exports.__esModule = true;
var ReactPlaceholder_1 = require("./ReactPlaceholder");
exports["default"] = ReactPlaceholder_1["default"];